import React from "react";

import classnames from "classnames";

import { maybeGetClosureFor } from "@kazoohr/helpers";

import { Checkbox } from "../Checkbox";
import { IconButton } from "../IconButton";

import styles from "./DataTable.scss";
import { CheckState, TableColumn } from "./types";

interface NestedTableCellProps {
  alignment?: string;
  checkState?: CheckState;
  columns?: TableColumn[];
  dataItem: Record<string, any>;
  dataKey: (item: Record<string, any>) => number | string;
  defaultAlignment?: string;
  firstColumn?: boolean;
  hasChildren?: boolean;
  isExpanded?: boolean;
  nestedLevel?: number;
  onToggleExpansionOne?: (id: number | string) => void;
  onToggleSelectOne: () => void;
  renderCell: (props: any) => React.ReactNode;
  width?: string;
  withCheckbox?: boolean;
}

export function NestedTableCell({
  alignment,
  dataItem,
  renderCell,
  nestedLevel = 0,
  withCheckbox,
  onToggleSelectOne,
  firstColumn = false,
  onToggleExpansionOne,
  hasChildren,
  isExpanded,
  checkState,
  dataKey,
  width,
}: NestedTableCellProps): React.ReactElement {
  const cellClass = classnames(styles.cell, {
    [styles[`align_${alignment}`]]: Boolean(alignment),
    [styles.nestedCellContainer]: firstColumn,
    [styles[`nestedCell-${nestedLevel}`]]: firstColumn,
    [styles.nestedCellWithChevron]: firstColumn && withCheckbox && hasChildren,
  });
  const id = dataKey(dataItem);
  return (
    <td className={cellClass} key={id} width={width}>
      {withCheckbox && (
        <Checkbox
          id={id}
          checked={checkState === "half-checked" || checkState === "checked"}
          indeterminate={checkState === "half-checked"}
          onChange={onToggleSelectOne}
          data-testid={`nested-cell-checkbox-${id}`}
        />
      )}
      <div className={styles.nestedCellOverflow}>{renderCell(dataItem)}</div>
      {firstColumn && hasChildren && (
        <IconButton
          icon={isExpanded ? "caret_up" : "caret_dn"}
          iconSize={8}
          size="small"
          onClick={maybeGetClosureFor(onToggleExpansionOne, id)}
          data-testid="expand-row-button"
        />
      )}
    </td>
  );
}
